import * as StaticPointsDrawerActions from './static-points-drawer.actions';
import type { StaticPointsDrawerState } from './static-points-drawer.models';

const { StaticPointsDrawerTypes } = StaticPointsDrawerActions;

type StaticPointsDrawerFunctions = Omit<typeof StaticPointsDrawerActions, 'StaticPointsDrawerTypes'>;
type ActionsResponses = ReturnType<StaticPointsDrawerFunctions[keyof StaticPointsDrawerFunctions]>;

const initialState: StaticPointsDrawerState = {
  type: null,
  visible: false,
  selectedTemplate: null,
  selectedStation: null,
  selectedTrapview: false
};

export default (state = initialState, action: ActionsResponses): StaticPointsDrawerState => {
  switch (action.type) {
    case StaticPointsDrawerTypes.TOGGLE_DRAWER:
      return {
        ...state,
        ...action.payload
      };

    case StaticPointsDrawerTypes.SELECT_TEMPLATE:
      return {
        ...state,
        selectedTemplate: action.payload
      };

    case StaticPointsDrawerTypes.EDIT_STATION:
      return {
        ...state,
        visible: true,
        selectedStation: action.payload
      };

    case StaticPointsDrawerTypes.CLEAR_SELECTED_STATION:
      return {
        ...state,
        selectedStation: null
      };

    case StaticPointsDrawerTypes.SELECT_TRAPVIEW:
      return {
        ...state,
        selectedTrapview: true
      };

    case StaticPointsDrawerTypes.CLEAR_SELECTED_TRAPVIEW:
      return {
        ...state,
        selectedTrapview: false
      };

    default:
      return state;
  }
};
